<template>
  <div class="spotlight-word-map" :style="{ 'background-color': backgroundColor }">
    <ul ref="list" class="spotlight-word-map__list">
      <li
        v-for="(entry, index) in wordMap"
        :key="entry.word"
        :style="{
          transform: `translate3d(${positions[index].left}px, ${positions[index].top}px, 0)`
        }">
        <a :href="entry.link">{{ entry.word }}</a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    wordMap: {
      type: Array,
      required: true
    },
    backgroundColor: {
      type: String
    }
  },
  data () {
    const positions = this.wordMap.map(() => {
      return { top: 0, left: 0 }
    })

    return {
      positions
    }
  },
  methods: {
    onResize () {
      this.calculatePositions()
    },
    calculatePositions () {
      const totalHeight = window.innerHeight
      const totalWidth = window.innerWidth
      const elements = this.$refs.list.querySelectorAll('li')
      let i = elements.length
      while (i--) {
        const element = elements[i]
        const top = Math.round(Math.random() * (totalHeight - element.clientHeight))
        // -16 for scroll bar
        const left = Math.round(Math.random() * (totalWidth - element.clientWidth - 16))
        this.$set(this.positions, i, { top, left })
      }
    }
  },
  created () {
    window.addEventListener('resize', this.onResize)
  },
  mounted () {
    this.calculatePositions()
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>
<style lang="stylus">
.spotlight-word-map
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  .spotlight-word-map__list
    li
      padding 0
      position absolute
      transition transform 500ms
      left 0
      top 0
      &:before
        display none
      a,
      a:visited
        color black !important
        background-image: linear-gradient(to right, black 50%, transparent 50%);
        &:hover
          background-size: 100% 1.5px;
          background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, black), color-stop(50%, black));
          background-image: linear-gradient(to right, black 50%, black 50%);
</style>
